import { AddCustomersComponent } from './customers/add-customers/add-customers.component';
import { CommonModule } from '@angular/common';
import { CustomersComponent } from './customers/customers.component';
import {
    DxTabPanelModule,
} from 'devextreme-angular';
import {
    MatFormFieldModule,
} from '@angular/material/form-field';
import { NgModule } from '@angular/core';
import { NgxLoadingModule } from 'ngx-loading';
import { RouterModule } from '@angular/router';
import { SalesService } from './sales.service';
import { SharedModule } from './../../template/shared/shared.module';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { routes } from './sales-routing.module';
import { NgScrollbarModule } from 'ngx-scrollbar';

@NgModule({
    imports: [
        NgScrollbarModule,
        NgxLoadingModule.forRoot({}),
        CommonModule,
        SharedModule,
        RouterModule.forChild(routes),
        SweetAlert2Module.forRoot(),
        MatFormFieldModule,
        DxTabPanelModule,
        
    ],
    declarations: [
        CustomersComponent,
        AddCustomersComponent,
    ],

   
    providers: [
        SalesService,
    ]
})
export class SalesModule { }
